import Vue from 'vue'
import axiosMain from 'axios'
import authFactory from '@/services/auth-factory'
// import { accessTokenDecoder, auth, client as axios } from './auth'
import AccessService from './access'
import config from '../config'
import router from '../router'
import store from '../store'
import Permission from '@/services/permission'
import Device from '@/services/device'
import ProductResource from '@/api/resources/product'
import UserResource from '@/api/resources/user'

const bus = new Vue()
const axios = axiosMain.create(config.api)
const auth = authFactory(axios, store)
const access = new AccessService(router, auth)
const permission = new Permission()
const device = new Device()
const productResource = new ProductResource(axios)
const userResource = new UserResource(axios)

export default {
  bus,
  axios,
  auth,
  access,
  permission,
  device,
  productResource,
  userResource
}
